import React, { useRef } from 'react';
import { Card, Row, Col, Button } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import DetailItem from '../../../../CSIComponents/DetailItem';
import { CalendarOutlined } from '@ant-design/icons';
import ApplicalbeDays from '../../../../CSIComponents/ApplicalbeDays';
interface propsTypes {
    //isEditable: void | any,
    cancelEditable: void | any,
    cancellationDetails: void | any,
    toggleToEditMode: void | any,
    setActiveTabKey: void | any,
}


const CancellationDetail = (props: propsTypes) => {
    const applicalbeDaysRef = useRef()
    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('Cancellation') }}>Back</Button>
                    </div>
                    <div>
                        <Button type="primary" className="db-edit-btn" onClick={props.toggleToEditMode}>Edit</Button>
                    </div>
                </div>
    } 

    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }} title={props?.cancellationDetails?.policycode} extra={edit()}>
                <div style={{ padding: "0 20px" }}>
                    <Row gutter={24}>
                        <Col span={6} className="col-margin">
                            <DetailItem value={props?.cancellationDetails?.policycode} label="Policy Code" />
                        </Col>
                        <Col span={12} className="col-margin">
                            <div style={{ display: 'inline-block', width: '100%' }}>
                                <div style={{ fontSize: 12, color: '#999999', height: '24px', "fontWeight": 600 }}>Start Date ~ End Date</div>
                                <div style={{ display: 'flex', width: '100%', textOverflow: 'ellipsis', borderBottom: '1px solid #CCCCCC', padding: '0 5px', fontSize: '14px', height: '32px', marginTop: '5px', lineHeight: '32px', overflow: 'hidden', color: '#333333' }}>
                                    <div style={{ flex: 1 }}>{props?.cancellationDetails?.start}</div>
                                    <span style={{ padding: '0 10px', marginLeft: -20 }}>~</span>
                                    <div style={{ flex: 1 }}>{props?.cancellationDetails?.end}
                                        <CalendarOutlined style={{ float: 'right', marginTop: 10 }} />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12} className="col-margin">
                            <ApplicalbeDays label="Applicable Days of the Week" valueList={props?.cancellationDetails?.valueList} ref={applicalbeDaysRef} readOnly={true} />
                        </Col>
                        <Col span={10}></Col>
                        <Col span={6} className="col-margin">
                            <DetailItem value={props?.cancellationDetails?.roomtypecode} label="Applies to Room Type Code" />
                        </Col>
                        <Col span={6} className="col-margin">
                            <DetailItem value={props?.cancellationDetails?.nonrefundable === 'true' ? 'Yes' : (props?.cancellationDetails?.nonrefundable === 'false' ? 'No' : '')} label="Non-refundable" />
                        </Col>
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default CancellationDetail;

